document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.custom-difference__tab');
  const grid = document.querySelector('.custom-difference__grid');

  if (!tabs.length || !grid) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Remove active from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      
      // Add active to clicked tab
      tab.classList.add('active');
      
      // Update grid class
      const target = tab.getAttribute('data-target');
      if (target === 'brand') {
        grid.classList.remove('show-competitor');
        grid.classList.add('show-brand');
      } else {
        grid.classList.remove('show-brand');
        grid.classList.add('show-competitor');
      }
    });
  });
});
